import axios from "../axios";

/**
 * Invoice API Service
 */
const invoiceApi = {
  /**
   * Get invoice by ID
   * @param {number|string} id 
   */
  getById: (id) => {
    return axios.get(`/Invoice/${id}`);
  },

  /**
   * Create a new invoice
   * @param {object} payload 
   */
  create: (payload) => {
    return axios.post("/Invoice", payload);
  },

  /**
   * Update an existing invoice
   * @param {number|string} id 
   * @param {object} payload 
   */
  update: (id, payload) => {
    return axios.put(`/Invoice/${id}`, payload);
  },

  /**
   * Approve an invoice
   * @param {number|string} id 
   */
  approve: (id) => {
    return axios.post(`/Invoice/approve/${id}`);
  },

  /**
   * Get next invoice number
   * @param {number|string} companyId 
   * @param {number|string} branchId 
   * @param {number|string} typeId 
   * @param {number|string} [userId] Optional for POS sequence
   */
  getNextNumber: (companyId, branchId, typeId, userId) => {
    let url = `/Invoice/next-number/${companyId}/${branchId}/${typeId}`;
    if (userId) url += `?userId=${userId}`;
    return axios.get(url);
  },

  /**
   * Get all invoices by company ID
   * @param {number|string} companyId 
   */
  getByCompany: (companyId) => {
    return axios.get(`/Invoice/by-company/${companyId}`);
  },

  // Navigation methods
  getLast: (companyId, typeId) => {
    return axios.get(`/Invoice/last/${companyId}/${typeId}`);
  },

  getFirst: (companyId, typeId) => {
    return axios.get(`/Invoice/first/${companyId}/${typeId}`);
  },

  getPrevious: (id) => {
    return axios.get(`/Invoice/previous/${id}`);
  },

  getNext: (id) => {
    return axios.get(`/Invoice/next/${id}`);
  }
};

export default invoiceApi;
